import { render, staticRenderFns } from "./diff_view.vue?vue&type=template&id=cb9bf258&scoped=true"
import script from "./diff_view.vue?vue&type=script&lang=js"
export * from "./diff_view.vue?vue&type=script&lang=js"
import style0 from "./diff_view.vue?vue&type=style&index=0&id=cb9bf258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9bf258",
  null
  
)

export default component.exports